import '../../App.css';
import { useEffect, useRef, useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.css';
import { useSelector } from 'react-redux';

function Message() {
    const message = useSelector((state) => state.message.value);
    const [toasts, setToasts] = useState([]);
    const idSeq = useRef(0);

    // 토스트별 타이머를 관리하는 Map<id, timeoutId>
    const timersRef = useRef(new Map());

    // 새 message -> 토스트 푸시 + 개별 타이머 설정
    useEffect(() => {
        if (!message) return;
        if (message.code == null || message.code === 0) return;

        const id = `${Date.now()}_${idSeq.current++}`;
        const type = message.code > 0 ? 'success' : 'error';
        const msg = message.msg ?? '';

        setToasts((prev) => [...prev, { id, type, msg }]);

        // 개별 타이머
        const tid = setTimeout(() => {
            setToasts((prev) => prev.filter((t) => t.id !== id));
            // 제거되면 타이머도 정리
            const timers = timersRef.current;
            if (timers.has(id)) {
                clearTimeout(timers.get(id));
                timers.delete(id);
            }
        }, 3000);

        timersRef.current.set(id, tid);

        // ❌ 예전처럼 여기서 clearTimeout을 반환하지 않습니다 (다음 메시지 들어오면 이전 타이머가 지워지는 문제 방지)
    }, [message]);

    // 언마운트 시 모든 타이머 정리 (메모리 누수 방지)
    useEffect(() => {
        return () => {
            for (const [, tid] of timersRef.current.entries()) {
                clearTimeout(tid);
            }
            timersRef.current.clear();
        };
    }, []);

    return (
        <div className="hb-toast-container">
            {toasts.map((t, idx) => (
                <div key={t.id} className={`hb-toast copy ${t.type}`}>
                    <div className="hb-toast__icon">
                        {t.type === 'success' ? (
                            <i className="fa-regular fa-circle-check" style={{ color: '#20B26C' }} />
                        ) : (
                            <i className="fa-regular fa-circle-xmark" style={{ color: '#EF454A' }} />
                        )}
                    </div>
                    <div className="hb-toast__msg">{t.msg}</div>
                </div>
            ))}
        </div>
    );
}

export default Message;
